var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"width":"100%","visible":_vm.visible,"before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('img',{staticClass:"full-img",attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }